import { ObjectSchema, object, string, boolean } from 'yup';
import { locale } from '../yup-locale';
import * as yup from 'yup';
import { VesselOwnershipTransfer } from '../../models/vessel-ownership-transfer';

export const vesselOwnershipTransferCommentLength = 200;

yup.setLocale(locale);

export function vesselOwnershipTransferValidator(): ObjectSchema<VesselOwnershipTransfer> {
    return object({
        id: string().uuid().required().nonNullable().strict(),
        vesselId: string().uuid().required().nonNullable().strict(),
        version: string().required().nonNullable().strict(),
        userName: string().required().nonNullable().strict(),
        userOid: string().required().nonNullable().strict(),
        ownershipStatus: string().required().nonNullable().strict(),
        assignerOid: string().nullable().defined().strict(),
        messageRead: boolean().required().nonNullable().strict(),
        comment: string().nullable().strict().max(vesselOwnershipTransferCommentLength),
    })
        .strict()
        .noUnknown() as ObjectSchema<VesselOwnershipTransfer>;
}
